export default __webpack_public_path__ + "static/media/24.1c82417d.png";